import React, { useState } from "react";
import MasterCrud from "./MasterCrud";

const entityOptions = [
  "category",
  "changephase",
  "closurecode",
  "closurecodeproblem",
  "closurecodetask",
  "Errors",
  "tasktype",
  "ChangeTemplates"
];

const ReportsPage: React.FC = () => {
  const [selectedEntity, setSelectedEntity] = useState<string>("");

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Manage Dropdowns</h1>

      {/* Entity Selector */}
      <div className="mb-6">
        <label className="block mb-2 font-semibold">
          Select entity to edit:
        </label>
        <select
          className="border px-3 py-2 rounded w-full"
          value={selectedEntity}
          onChange={(e) => setSelectedEntity(e.target.value)}
        >
          <option value="">-- Select --</option>
          {entityOptions.map((entity) => (
            <option key={entity} value={entity}>
              {entity.charAt(0).toUpperCase() + entity.slice(1)}
            </option>
          ))}
        </select>
      </div>

      {/* Show MasterCrud for selected entity */}
      {selectedEntity && (
        <div>
          <MasterCrud entityType={selectedEntity as any} />
        </div>
      )}
    </div>
  );
};

export default ReportsPage;
